import StepperTitle from './StepperTitle';

export default StepperTitle;
